import request from '@/utils/request'

// 查询作品评价管理列表
export function listComments(query) {
  return request({
    url: '/OmdWorkComments/comments/list',
    method: 'get',
    params: query
  })
}

// 查询作品评价管理详细
export function getComments(id) {
  return request({
    url: '/OmdWorkComments/comments/' + id,
    method: 'get'
  })
}

// 新增作品评价管理
export function addComments(data) {
  return request({
    url: '/OmdWorkComments/comments',
    method: 'post',
    data: data
  })
}

// 修改作品评价管理
export function updateComments(data) {
  return request({
    url: '/OmdWorkComments/comments',
    method: 'put',
    data: data
  })
}

// 删除作品评价管理
export function delComments(id) {
  return request({
    url: '/OmdWorkComments/comments/' + id,
    method: 'delete'
  })
}
